import HomeIcon from '@mui/icons-material/Home';
import OutdoorGrillIcon from '@mui/icons-material/OutdoorGrill';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { Link as RouterLink } from 'react-router';

import { registerLocaleResources, useTranslation } from '@/modules/i18n/useTranslation';
import { useLocalizedPath } from '@/modules/routing';

import LanguagePicker from '../LanguagePicker';
import ThemeSwitch from '../ThemeSwitch';
import en from './locales/en.json';
import es from './locales/es.json';
import ru from './locales/ru.json';
import { styles } from './style';

registerLocaleResources('SiteMap', { en, es, ru });

declare module '@/modules/i18n/namespaces' {
    interface LocaleNamespaces {
        SiteMap: typeof en;
    }
}

// color="inherit" keeps MUI v4's neutral hover; the default primary color would tint it green
const SiteMap = () => {
    const { t } = useTranslation('SiteMap');
    const localize = useLocalizedPath();
    return (
        <Box sx={styles.layout}>
            <Button component={RouterLink} to={localize('/')} color="inherit" sx={styles.link} startIcon={<HomeIcon/>}>
                {t('home')}
            </Button>
            <Button component={RouterLink} to={localize('/cookbook')} color="inherit" sx={styles.link} startIcon={<OutdoorGrillIcon/>}>
                {t('cookbook')}
            </Button>
            <Button component={RouterLink} to={localize('/glagol_espanol')} color="inherit" sx={styles.link} startIcon={<OutdoorGrillIcon/>}>
                {t('glagolEspanol')}
            </Button>
            <Box sx={styles.controls}>
                <ThemeSwitch/>
                <LanguagePicker/>
            </Box>
        </Box>
    );
};

export default SiteMap;
